module.exports = __webpack_public_path__ + "static/media/VV_AMB.f6305f9d.mp3";